import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = {
  key: 0,
  class: "error"
}
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "error"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "error"
}
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = {
  key: 0,
  class: "error"
}
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "checkbox-inline-wrapper" }
const _hoisted_14 = { class: "checkbox-wrapper" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "controls" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $props.isOpen,
    onClose: $setup.close
  }, {
    content: _withCtx(() => [
      _createElementVNode("form", {
        class: "default-form",
        onSubmit: _withModifiers($setup.handleSubmit, ["prevent"])
      }, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "modal-title" }, "Approve Contract Form", -1)),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", null, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "Settlement Date", -1)),
              _createVNode($setup["DatePicker"], {
                modelValue: $setup.form.settlementDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.settlementDate) = $event)),
                disabled: $setup.disabled,
                classField: "input input--focus input-large",
                max: $setup.maxSettlementDate
              }, null, 8, ["modelValue", "disabled", "max"])
            ]),
            ($setup.errors.settlementDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($setup.errors.settlementDate), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", null, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "Prompt Settlement Discount", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "input input--focus input-large",
                type: "number",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.settlementDiscount) = $event)),
                placeholder: "Enter discount amount",
                min: "0",
                step: "0.01",
                disabled: $setup.disabled
              }, null, 8, _hoisted_5), [
                [_vModelText, $setup.form.settlementDiscount]
              ])
            ]),
            ($setup.errors.settlementDiscount)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.errors.settlementDiscount), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", null, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "Finance Terms", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "input input--focus input-large",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.financeTerms) = $event)),
                placeholder: "Enter finance terms",
                rows: "3",
                disabled: $setup.disabled
              }, null, 8, _hoisted_8), [
                [_vModelText, $setup.form.financeTerms]
              ])
            ]),
            ($setup.errors.financeTerms)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($setup.errors.financeTerms), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", null, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "Contract Preparation Fee Paid Date", -1)),
              _createVNode($setup["DatePicker"], {
                modelValue: $setup.form.contractPreparationFeeDate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.contractPreparationFeeDate) = $event)),
                disabled: $setup.disabled,
                classField: "input input--focus input-large",
                max: $setup.maxSettlementDate
              }, null, 8, ["modelValue", "disabled", "max"])
            ]),
            ($setup.errors.contractPreparationFeeDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.errors.contractPreparationFeeDate), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label" }, "Build contract required prior to settlement?", -1)),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  class: "checkbox",
                  id: "isBuildContractRequired",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.isBuildContractRequired) = $event)),
                  disabled: $setup.disabled
                }, null, 8, _hoisted_15), [
                  [_vModelCheckbox, $setup.form.isBuildContractRequired]
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("label", {
                  class: "checkbox-label",
                  for: "isBuildContractRequired"
                }, "Yes", -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            class: "button default cancel",
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.close())),
            disabled: $setup.disabled
          }, "Cancel", 8, _hoisted_17),
          _createElementVNode("button", {
            class: "button default primary",
            type: "submit",
            disabled: $setup.disabled || !$setup.isFormValid
          }, _toDisplayString($setup.disabled ? "Processing..." : "Approve"), 9, _hoisted_18)
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["is-open"]))
}